import { UniqMap } from 'src/lib/UniqMap';

import { GENERATION_TOOL_GROUP, type GenerationToolGroup } from './const';

interface GroupProps {
  title: string;
}

const GROUP_PROPS = new UniqMap<GenerationToolGroup, GroupProps>();
GROUP_PROPS.add(GENERATION_TOOL_GROUP.generalWriting, {
  title: 'General Writing',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.ads, {
  title: 'Ads',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.landingPage, {
  title: 'Website',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.social, {
  title: 'Social',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.email, {
  title: 'Email',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.ecommerce, {
  title: 'Ecommerce',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.anyCopy, {
  title: 'Prompt',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.imageOld, {
  title: 'Images',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.images, {
  title: 'Images',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.articleBlog, {
  title: 'Blog',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.boost, {
  title: 'Content Improver',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.campaigns, {
  title: 'Campaigns',
});
GROUP_PROPS.add(GENERATION_TOOL_GROUP.customMultiPrompt, {
  title: 'Saved',
});

const getGroupProp = (
  type: GenerationToolGroup,
  propName: keyof GroupProps,
  defaultValue?: string
): string | undefined => {
  const props = GROUP_PROPS.get(type);
  if (props && props[propName] != null) {
    return props[propName];
  }
  return defaultValue;
};

export const getToolGroupTitle = (
  toolGroup: GenerationToolGroup,
  defaultValue = '< group title not found >'
): string | undefined => getGroupProp(toolGroup, 'title', defaultValue);
